/**
 * Audit Log page — localization manifest.
 */
export const auditManifest: readonly string[] = [
  "audit.title",
  "audit.action",
  "audit.actor",
  "audit.resource",
  "audit.timestamp",
  // Shared
  "nav.auditLog",
  "common.loading",
  "common.noData",
  "common.search",
  "common.filter",
  "common.export",
  "common.date",
] as const;
